"use client";

import { BSRChevronDown } from "./bsr/BSRChevronDown";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ChevronDown as LegacyChevronDown } from "./legacy/ChevronDown";

export const ChevronDown = createBSRExperimentIcon(
  LegacyChevronDown,
  BSRChevronDown
);
